import React from "react";
import './Usage.css';
import { useNavigate } from "react-router-dom";
import ButtonHallow from "../../elements/Button/ButtonHallow";

const UsageModal = ({ isOpen, onClose, data,alertType,expireStatus, datediff }) => {
    if (!isOpen) return null;

    const keyMaping = {
        job: "Job Postings",
        resume: "Resume Views",
        email: "Emails Sent",
        users: "Recruiters",
        jd: "JD Creations",
        job_ai: "Job AI Usage",
        token: "Tokens",
        email_ai_usage: "Email AI Usage",
        sms_count: "SMS Sent",
        whats_app_count: "WhatsApp Messages",
        no_of_cand: "Candidates",
        email_count: "Total Emails",
        storage_space: "Storage Space",
        resume_file_size_mb: "Resume File Size (MB)"
    };    

      const navigate = useNavigate();
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99]">
            <div className="bg-white p-6 rounded-lg shadow-lg w-[600px] max-h-[90vh] relative">
                <button
                    onClick={onClose}
                    disabled={expireStatus === "expired" && datediff >= 7}
                    className={` top-3 right-3 text-gray-600 hover:text-gray-800 text-xl ${expireStatus === "expired" && datediff >= 7 ? ' hidden ':' absolute '}`}
                >
                    &times;
                </button>

                <h2 className="text-xl font-semibold mb-4 text-center">Usage Overview</h2>

                <div className="flex-1 overflow-y-auto max-h-[calc(90vh-92px)] mb-4">
                    {expireStatus ? (
                        (expireStatus === "expired") ? 
                            (
                                <div className="expired-alert mb-4">
                                <div className="expired-icon">⚠️</div>
                                <span className="expired-message">
                                    {datediff >= 3 
                                        ? "Your plan expired a while ago. Upgrade now to regain access to all features!" 
                                        : "Your plan has just expired! Renew now to avoid interruptions."}
                                </span>
                                <ButtonHallow 
                                    content="Upgrade Now" 
                                    className="expired-button" 
                                    onClick={() => navigate("/pricing")} 
                                />
                            </div>)
                        : (expireStatus === "expiring" && (
                            <div className="custom-alert expiring"> 
                                <p className="mb-0">Your subscription is about to expire in {datediff} days.</p>
                            </div>
                        ))
                    ) : alertType === "warning" ? (
                        <div className="custom-alert warning"> 
                            <p className="mb-0">You are about to reach your usage limit.</p>
                        </div>
                    ) : alertType === "danger" && (
                        <div className="custom-alert danger"> 
                            <p className="mb-0">You have reached your usage limit.</p>
                        </div>
                    )}
                        <div className="grid grid-cols-2 gap-4">
                    {Object.entries(data).map(([key, value]) => {
                        const totalUsage = value.total_usage || 0;
                        const planLimit = value.plan_limit || 0;

                        const planLimitDisplay = planLimit === 99999 ? "Unlimited" : planLimit;

                        const progressPercentage = planLimit === 0 ? 0 : (totalUsage / planLimit) * 100;

                        return (
                            <div key={key} className="space-y-1">
                                <div className="flex justify-between text-sm font-medium capitalize">
                                    <span>{keyMaping[key]}</span>
                                    <span>{`${totalUsage} / ${planLimitDisplay}`}</span>
                                </div>
                                <div className="w-full h-2 bg-gray-300 rounded-full overflow-hidden">
                                    <div
                                        className="h-full bg-green-500 transition-all duration-300"
                                        style={{ width: `${progressPercentage}%` }}
                                    ></div>
                                </div>
                            </div>
                        );
                    })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UsageModal;
